import apiClient from '../config/axiosConfig';
import * as types from './actionTypes';
import { handleError } from '../errors/handleError';

export function errorHandler(dispatch, error, type) {
    const errorMessage = handleError(error, true);
    dispatch({
        type,
        error: errorMessage,
    });
}

export function getChmsCalendarFeeds() {
    return function (dispatch) {
        dispatch({
            type: types.GET_CALENDARS_PENDING,
        });
        const organizationId = localStorage.getItem('OrganizationId');
        return apiClient.get(`/v2/calendar/sccrm?organizationId=${organizationId}`)
            .then((feeds) => {
                dispatch({
                    type: types.GET_CALENDARS_SUCCESS,
                    payload: feeds.data?.data?.calendars,
                });
            })
            .catch((error) => {
                errorHandler(dispatch, error.response, types.GET_CALENDARS_FAILED);
            });
    };
}
